jQuery(document).ready(function () {
    jQuery('.testimonial-slide').slick({
        arrows: false,
        dots: true
    });
    jQuery('.slick-dots').addClass('m-page-indicators');
});
